import { getInitData } from '@/utils/getInitData';
import { settings } from '@/api/config';

export const getRef = async () => {
  const initData = getInitData();
  console.log('Init data:', initData);

  const res = await fetch(
    `${settings.url}api/users/ref?initData=${encodeURIComponent(initData)}`,
  );

  const contentType = res.headers.get('content-type');
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to fetch ref data: ${errorText}`);
  }

  if (contentType?.includes('application/json')) {
    return res.json();
  } else {
    const text = await res.text();
    throw new Error(`Invalid JSON: ${text}`);
  }
};

export const claimRef = async () => {
  const initData = getInitData();

  const res = await fetch(
    `${settings.url}api/users/ref/claim?initData=${encodeURIComponent(initData)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    },
  );

  const contentType = res.headers.get('content-type');
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to claim ref reward: ${errorText}`);
  }

  if (contentType?.includes('application/json')) {
    return res.json();
  } else {
    const text = await res.text();
    throw new Error(`Invalid JSON: ${text}`);
  }
};
